import { graphql } from 'msw';
import productUpdatesMockData from '../../../../../features/dashboard/components/AppHeader/fixtures/data.json';

export const strapi = graphql.link('http://localhost:3004/product-updates/graphql');

export default strapi.query('GetProductUpdates', (req, res, ctx) =>
    res(ctx.data(productUpdatesMockData)),
);
